import { useQuery, useMutation } from 'react-query'
import client, { deleteclient, patchclient } from './api-client';

const parcelQueryConfig = {
  staleTime: 1000 * 60 * 60,
  cacheTime: 1000 * 60 * 60,
}

async function fetchParcelsCNPs(user, parcel) {
  const data = await client(`parcels/${parcel.id}/cnps/?client_id=${user.id}`)
  return data
}

export function useParcelCNPs(user, parcel) {
  return useQuery(['parcel', parcel, user.username], () => fetchParcelsCNPs(user, parcel), {
    refetchAllOnWindowFocus: false,
    enabled: !!parcel,
    ...parcelQueryConfig
  });
}

async function fetchParcelCNPFormData(user, parcel) {
  const data = await client(`parcels/${parcel.id}/cnp-form-data/?client_id=${user.id}`)
  return data
}

export function useParcelCNPFormData(user, parcel) {
  return useQuery(['parcel', parcel], () => fetchParcelCNPFormData(user, parcel), {
    refetchAllOnWindowFocus: false,
    enabled: !!parcel,
    ...parcelQueryConfig
  });
}


async function fetchSmallParcels(user) {
  const data = await client(`smallparcels/?client_id=${user.id}`)
  return data
}

export function useSmallParcels(user) {
  return useQuery(['smallparcels', user.id], () => fetchSmallParcels(user), {
    refetchAllOnWindowFocus: false,
    ...parcelQueryConfig
  });
}


async function updateParcel(parcel) {
  const data = await patchclient(`parcels/${parcel.id}/`, { body: parcel })
  return data;
}

export function useUpdateParcelMutation(parcel) {
  return useMutation((parcel) => updateParcel(parcel));
}

async function fetchParcelsTotalHectares(user) {
  const data = await client(`parcels/total_hectares/?client_id=${user.id}`)
  return data
}

export function useParcelsTotalHectares(user) {
  return useQuery(['parcels_total_hectares', user.username], () => fetchParcelsTotalHectares(user), {
    refetchAllOnWindowFocus: false,
    enabled: false,
    ...parcelQueryConfig
  });
}